import {
  getWebTranslationUrls,
  setTranslationUrlProvider,
} from '@carecircle/core';

/**
 * Initializes the translation system for the web platform
 * This should be called during app initialization
 */
export const initializeWebTranslations = (): void => {
  setTranslationUrlProvider(getWebTranslationUrls);
};
